
define('text!modules/pagination/pagination_item_template.html',[],function () { return '<% if (!truncate || (truncate && visible)) { %>\r\n  <a href="#" class="<% if(active) { %>active<% } %>" data-offset="<%- offset %>" data-id="<%- id %>"><%- label %></a>\r\n<% } else if (truncate && truncated) { %>\r\n  <a href="#" class="truncated">...</a>\r\n<% } %>\r\n';});

